import * as React from 'react'
import { InnerHtmlWrapper } from '../../../../../../../../EntryPoint/Frontend/legacy/public_site/components/utils/InnerHtmlWrapper'

export const NestedTextBlockLayout = (props: { body?: string }) => {
  const { body } = props
  return body ? (
    <div className="block-nested block-nested--text">
      <div className="block__inner">
        <InnerHtmlWrapper text={body} className="block__text" />
      </div>
    </div>
  ) : (
    <></>
  )
}
